export const SET_TRANSLATIONS = "SET_TRANSLATIONS"